import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedRoadLayer() {
  if (hasYamlRight('road')) return {}

  const roadUrl = RIGHTS('map.layers.road.url', 'OSM'),
    isOSM = roadUrl === 'OSM',
    isBingRoad = roadUrl.indexOf('BING') > -1,
    centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    visible: true,
    data: { icon: 'road' },
    url: roadUrl,
    type: isOSM ? 'OSM' : isBingRoad ? roadUrl : 'tileXYZ',
    maxZoom: 19 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
  }
}
